export default {
    facultyProfilePageGuidance: [],
    facultyProfilePageCoGuidance: []
}